import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

import FullScreenLayout from '@/shared/components/layout/FullScreenLayout';
import PageWrapper from './PageWrapper';

import { PATH } from '@/shared/constants';

const AttendanceTabletPage = lazy(() => import('@/pages/admin/attendance/tablet/Page'));

/**
 * 출결 태블릿 — GNB/LNB 없는 전체 화면(키오스크).
 * 스캔 API는 단말 인증키만 쓰므로 로그인 가드(AuthRoute) 밖에 두어, 관리자 세션이 만료돼도 스캔이 계속된다.
 * 단말 최초 등록만 관리자 로그인이 필요하다 (페이지 안에서 안내).
 * 웹 전용(index.tsx에서만 등록) — admin 코드가 네이티브 번들에 들어가지 않도록 publicRoutes에 넣지 않는다.
 */
export const attendanceTabletRoutes: RouteObject = {
  element: <FullScreenLayout />,
  children: [
    {
      path: PATH.PUBLIC.ATTENDANCE_TABLET,
      element: (
        <PageWrapper>
          <AttendanceTabletPage />
        </PageWrapper>
      ),
    },
  ],
};
